import React, { useMemo } from 'react';
import { checkATS } from '../utils/atsChecker';
import './ATSScore.css';

const ATSScore = ({ data, template, layout }) => {
  const result = useMemo(() => checkATS(data, template, layout), [data, template, layout]);

  const scoreColor = result.score >= 80 ? 'var(--success)' : result.score >= 50 ? 'var(--warning)' : 'var(--danger)';

  return (
    <div className="ats-score">
      <div className="ats-header">
        <span className="ats-icon">📊</span>
        <span className="ats-title">ATS Readiness</span>
      </div>

      <div className="ats-gauge">
        <svg viewBox="0 0 120 120" className="ats-gauge-svg">
          <circle cx="60" cy="60" r="54" fill="none" stroke="var(--gray-200)" strokeWidth="8" />
          <circle cx="60" cy="60" r="54" fill="none" stroke={scoreColor} strokeWidth="8"
            strokeDasharray={`${(result.score / 100) * 339.3} 339.3`}
            strokeLinecap="round" transform="rotate(-90 60 60)" />
        </svg>
        <div className="ats-score-value" style={{ color: scoreColor }}>{result.score}</div>
        <div className="ats-score-label">/100</div>
      </div>

      <div className="ats-checks">
        {result.checks.map((check, i) => (
          <div key={i} className={`ats-check ${check.pass ? 'pass' : 'fail'} ${check.severity || ''}`}>
            <span className="check-icon">{check.pass ? '✓' : '✕'}</span>
            <span className="check-msg">{check.msg}</span>
          </div>
        ))}
      </div>

      <div className="ats-tip">
        {result.score >= 80 ? 'Your resume is well-optimized for ATS systems.' :
         result.score >= 50 ? 'Some improvements needed for better ATS compatibility.' :
         'Significant improvements needed for ATS systems.'}
      </div>
    </div>
  );
};

export default ATSScore;
